// Global legal footer: Amazon Associates operating-agreement disclosure on every page.
export const SiteFooter = () => (
  <div data-testid="site-footer" className="border-t border-white/5 bg-[#050505]">
    <p
      data-testid="amazon-associate-disclosure"
      className="mx-auto max-w-[1600px] min-[2200px]:max-w-[2200px] px-5 sm:px-8 py-4 font-mono text-[10px] tracking-[0.08em] text-white/35"
    >
      As an Amazon Associate, ReelVault earns from qualifying purchases.
    </p>
  </div>
);
